import Vec3 from '../custom/Vec3.js';
import Vec2 from '../custom/Vec2.js';
import {doc} from './docs.js';


doc(
    "vec3",
    {
    },
    "Creates a 3-component list made out of numbers",
    () => 0,
    {
        inlets: 0,
    }
);
    
export const vec3 = (object) => {
    const o = new Vec3(object);
    object.needsLoad = true;
    return () => {
        o.sendObject();
    };
};

doc(
    "vec2",
    {
    },
    "Creates a 2-component list made out of numbers",
    () => 0,
    {
        inlets: 0,
    }
);
    
export const vec2 = (object) => {
    const o = new Vec2(object);
    object.needsLoad = true;
    return () => {
        o.sendObject();
    };
};

